import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'highlight.js/styles/github.css';
import './styles/tokens.css';
import './styles/app.css';
import { App } from './app/App';
import { applyTheme, type Theme } from './hooks/useTheme';

applyTheme(((() => { try { return localStorage.getItem('lumnos.theme'); } catch { return null; } })() as Theme) ?? 'system');
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
